<style lang="scss">
  @import '../resources/scss/newsletter';
</style>

<script lang="ts">
  import { locale } from 'svelte-i18n'
  import { fallbackLocale } from '../services/i18n'
  import { newsletterData } from '../stores/stores'
  import GrowingFamily from '../components/Growing_Family.svelte'
  import LibraryPlatform from '../components/Library_Platform.svelte'
  import Partners from '../components/Partners.svelte'
  import SubscribeNewsletter from '../components/Subscribe_Newsletter.svelte'
  import { fetchNewsletter } from '../controllers/NewsletterController'
  import type Newsletter from '../api/rest/directus-cms/newsletter/model/Newsletter'

  let lang = $locale ?? fallbackLocale

  $: lang = $locale ?? fallbackLocale

  let newsletter_data: Newsletter | undefined

  void fetchNewsletter(lang).then(() => (newsletter_data = $newsletterData ?? undefined))
</script>

{#if $newsletterData}
  <div class="container-xxl py-section">
    {#if newsletter_data}
      {@debug newsletter_data}
      <div class="row pb-5">
        <div class="col-12 text-start">
          <h1 class="h1 mb-3 text-neutral-a">{newsletter_data.title}</h1>
        </div>
      </div>
    {/if}
    <div class="row newsletter-container">
      {#each $newsletterData.items as $item}
        {#if $item.title}
          <div class="col-6 col-md-4 col-xl-3 px-4 pb-5">
            <a
              href={$item.url}
              target="_blank"
              rel="noopener noreferrer"
              class="h4 d-block mb-3 text-neutral-b"
            >
              {$item.title}
            </a>
          </div>
        {/if}
      {/each}
    </div>
  </div>
{/if}
<LibraryPlatform />
<GrowingFamily />
<SubscribeNewsletter />
<Partners />
